import { makeZodI18nMap } from "zod-i18n-map";
const initI18nZodMap = (i18n) => makeZodI18nMap({ ns: "zod", t: i18n.t, handlePath: false });
export {
  initI18nZodMap
};
//# sourceMappingURL=zod.js.map